<template>
	<form @submit.prevent="() => false" class="flex flex-col divide-y divide-base-100">
		<div v-for="(listItem, index) in modelValue" :key="listItem" class="flex gap-1 items-center py-1">
			<span class="pr-2">&bullet;</span>
			<template v-if="!readOnly">
				<input type="text" :value="listItem" class="grow input bg-base hover:ring-1 focus:bg-base-100" @change="update($event, index)" />
				<button type="button" class="btn btn-circle btn-ghost" @click="remove(index)">
					<TrashIcon class="w-4 h-4" />
				</button>
			</template>
			<template v-else>
				<span class="py-2">{{ listItem }}</span>
			</template>
		</div>
	</form>
	<form v-if="!readOnly && showNewInput" @submit.prevent="add" class="flex items-center gap-1 justify">
		<span class="pr-2">&bullet;</span>
		<input type="text" class="input bg-base focus:bg-base-100 w-full grow" ref="new-input" @blur="add($event)" @paste="handlePaste($event)" />
	</form>

	<div class="flex items-center gap-1 justify">
		<span class="pr-2 text-transparent">&bullet;</span>
		<button v-if="!readOnly" type="button" @click="showNewInputField()" class="h-6 w-full rounded border border-dashed text-center relative flex justify-center items-center hover:bg-base-100 mt-4">
			<PlusIcon class="w-3 h-3"></PlusIcon>
		</button>
	</div>

</template>

<script lang="ts">
import { TrashIcon, PlusIcon } from '@heroicons/vue/24/outline';

export default {

	props: {
		modelValue: {
			type: Array,
			required: true,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
	},

	components: {
		TrashIcon, PlusIcon,
	},

	data() {
		return {
			showNewInput: false,
		};
	},

	mounted() {
		if(!this.modelValue || !this.modelValue.length) {
			this.showNewInputField();
		}
	},

	methods: {

		showNewInputField() {
			this.showNewInput = true;
			this.focusNewInput();
		},

		focusNewInput() {
			setTimeout(() => {
				if(this.$refs['new-input']) {
					this.$refs['new-input'].focus();
				}
			}, 100);
		},

		add(e) {
			let target = null;
			let isFormSubmit = false;

			if(e.target.length) {	// form submission (enter key)
				target = e.target[0];
				isFormSubmit = true;
			} else {	// field update event (blur event)
				target = e.target;
			}

			if(!target.value) {
				if (isFormSubmit) {
					this.focusNewInput();
				}
				return;
			}
			let updatedList = [...this.modelValue];
			updatedList.push(
				target.value
			);
			this.$emit('update:modelValue', updatedList);
			target.value = '';

			if (isFormSubmit) {
				target.focus();
			}
		},

		remove(index) {
			let updatedList = [...this.modelValue];
			updatedList.splice(index, 1);
			this.$emit('update:modelValue', updatedList);

			if(updatedList.length == 0) {
				this.showNewInputField();
			}
		},

		update(e, index) {
			if (e.target.value == '') {
				this.remove(index);
				return;
			}
			let updatedList = [...this.modelValue];
			updatedList[index] = e.target.value;
			this.$emit('update:modelValue', updatedList);
		},

		handlePaste(e) {
			const text = e.clipboardData.getData('text');
			const lines = text.split('\n').map((l: string) => l.replace(/^(\d+\.|\•|\-)\s*/, '')).filter(Boolean);

			if (lines.length > 1) {
				e.preventDefault();
				this.$emit('update:modelValue', [...this.modelValue, ...lines]);
				e.target.value = '';
			}
		},

	}
}
</script>
